import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlertComponent } from '@nx-vigil/core/web/alert/feature';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, AlertComponent],
  selector: 'identity-root',
  template: `<core-alert /><router-outlet></router-outlet>`,
  styles: ``,
})
export class AppComponent {}
